import { useHandleError } from "@/hooks/useHandleError";
import { usePhoneNumberVerifyBase } from "@roman/shared/hooks/usePhoneNumberVerifyBase";

export const usePhoneNumberVerify = () => {
  return usePhoneNumberVerifyBase(useHandleError);
};
